<template>
  <!-- 返回弹窗 -->
<el-dialog  :visible.sync="dialogVisibles"  custom-class="dialogVisibleReurnResource">
   <div class="dialog-modl">
     <div>
      <img src="@/assets/img/task/task／Warning.png" alt="" />
     </div>
     <div class="dialog-modl-right">你确定要删除该课程么？</div>
   </div>

   <span slot="footer" class="dialog-footer">
     <el-button @click="dialogVisibles = false" class="dialog-footer-btn"
       >取 消</el-button
     >
     <el-button
       type="primary"
       style="margin-left: 16px"
       @click="delID()"
       class="dialog-footer-btn"
       >确 定</el-button
     >
   </span>
 </el-dialog>
</template>
<script>
export default {
    props: {
        dialogVisible: {
         type: Boolean,
         default: false,
    },
    rowId:{
        type:Number,
    }
  },
  data(){
    return{
    }
  },
  computed: {
    dialogVisibles: {
      get() {
        return this.dialogVisible
      },
      set(dialogVisible) {
        this.$emit("input", dialogVisible)
      }
    }
  }
,
  methods: {
    delID() {
      this.$emit('openEvent','true')
      this.$request

        .post(
          `/sys/common/updateTaskStatus?taskId=${this.rowId}&status=${7}`,
          {}
        )
        .then((res) => {

        if(res.message){
          this.$message.error(res.message)
          this.$emit('closeError','true')
          this.dialogVisibles = false;
          return
        }
        let tabName = this.$store.state.contentTabsActiveName
        if (tabName === 'home') {
         return false
       }
       this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
       (item) => item.name !== tabName
     )
     if (this.$store.state.contentTabs.length <= 0) {
       this.$store.state.sidebarMenuActiveName =
         this.$store.state.contentTabsActiveName = 'home'
       return false
     } // 当前选中tab被删除
     if (tabName === this.$store.state.contentTabsActiveName) {
       this.$router.push({
         name: this.$store.state.contentTabs[
           this.$store.state.contentTabs.length - 1
         ].name,
       })
     }
          this.$router.push({
            path:"/task/select",
        });
       this.$message.success("删除成功")
        this.$emit('closeEvent','true')
        });
      this.dialogVisibles = false;
    },
  },
}
</script>
<style lang="scss">
.dialogVisibleReurnResource{
width: 360px!important;
height: 136px;
background: #FFFFFF;
box-shadow: 0px 9px 28px 8px rgba(0,0,0,0.05), 0px 6px 16px 0px rgba(0,0,0,0.08), 0px 3px 6px -4px rgba(0,0,0,0.12);
border-radius: 4px;
.el-dialog__headerbtn{
position: absolute;
 top: 6px;
 right: 9px;
 padding: 0;
 background: 0 0;
 border: none;
 outline: 0;
 cursor: pointer;
 font-size: 16px;
}
.el-dialog__body{
padding: 30px 20px;
 margin-top: -12px;

}
.dialog-footer-btn{
border-radius: 4px!important;
}
.el-dialog__footer{
border: 0px !important;
 margin-top: -11px;
 margin-right: 15px;
}
       .dialog-modl {
   height: 19px;
   display: flex;
    align-content: center;

img {
 width: 24px;
 height: 24px;
 margin-right: 8px;
 margin-left: 9px;
 margin-top: -18px;
}
.dialog-modl-right {
 width: 280px;
height: 24px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC, sans-serif;
font-weight: 400;
color: #252628;
line-height: 24px;
margin-top: -11px
}
}
}
</style>
